import React from 'react';
import { Sidebar } from './Sidebar';
import { Search, Bell } from 'lucide-react';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen bg-catalyst-cream flex" data-id="element-38">
      <Sidebar data-id="element-39" />
      <div className="flex-1 ml-64 flex flex-col" data-id="element-40">
        {/* Top Header */}
        <header className="h-20 bg-white border-b border-gray-200 flex items-center justify-between px-8 sticky top-0 z-10" data-id="element-41">
          <div className="flex-1 max-w-xl" data-id="element-42">
            <div className="relative" data-id="element-43">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} data-id="element-44" />
              <input type="text" placeholder="Search courses, members, or resources..." className="w-full pl-10 pr-4 py-2 bg-catalyst-off-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-catalyst-mustard/50 focus:border-catalyst-mustard transition-all text-sm" data-id="element-45" />
            </div>
          </div>
          <div className="flex items-center gap-6" data-id="element-46">
            <button className="relative text-gray-500 hover:text-catalyst-black transition-colors" data-id="element-47">
              <Bell size={20} data-id="element-48" />
              <span className="absolute -top-1 -right-1 w-2 h-2 bg-catalyst-mustard rounded-full" data-id="element-49"></span>
            </button>
            <div className="w-px h-6 bg-gray-200" data-id="element-50"></div>
            <div className="flex items-center gap-3 cursor-pointer" data-id="element-51">
              <div className="text-right hidden md:block" data-id="element-52">
                <p className="text-sm font-semibold text-catalyst-black" data-id="element-53">
                  Sarah Jenkins
                </p>
                <p className="text-xs text-gray-500" data-id="element-54">Cohort 1</p>
              </div>
              <div className="w-9 h-9 rounded-full bg-catalyst-mustard flex items-center justify-center text-catalyst-black font-bold text-sm shadow-sm" data-id="element-55">
                SJ
              </div>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="flex-1 p-8 overflow-y-auto" data-id="element-56">
          <div className="max-w-6xl mx-auto" data-id="element-57">{children}</div>
        </main>
      </div>
    </div>;
}